import { render, staticRenderFns } from "./editForm.vue?vue&type=template&id=0c6d55b4&scoped=true&"
import script from "./editForm.vue?vue&type=script&lang=js&"
export * from "./editForm.vue?vue&type=script&lang=js&"
import style0 from "./editForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./editForm.vue?vue&type=style&index=1&id=0c6d55b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6d55b4",
  null
  
)

export default component.exports